<template>
  <div class="custom-select" :class="{ 'is-disabled': disabled, 'is-open': isOpen }" @pointerdown.stop.prevent="toggleDropdown">
    <div class="select-header">
      <span class="selected-value">
        {{ selectedOption ? selectedOption.label : placeholder }}
      </span>
      <i class="arrow-icon" :class="{ rotate: isOpen }"></i>
    </div>
    <div class="options-list" v-show="isOpen" @click.stop>
      <div v-for="(option, index) in options" :key="index" class="option-item" :class="{
        'is-selected': isOptionSelected(option),
        'is-disabled': option.disabled,
      }" @pointerdown.stop.prevent="handleOptionClick(option)" :disabled="option.disabled">
        <span class="sp sp1">{{ option.label }}</span>
        <span class="sp sp2"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomSelect',
  props: {
    // 选项列表，格式: [{ label: '选项1', value: '1' }, ...]
    options: {
      type: Array,
      required: true,
      validator: value => {
        return value.every(
          option =>
            typeof option === 'object' &&
            'label' in option &&
            'value' in option,
        )
      },
    },
    // 默认选中值
    value: {
      type: [String, Number, Boolean, Object],
      default: null,
    },
    // 占位文本
    placeholder: {
      type: String,
      default: '请选择',
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 是否展开下拉列表
      isOpen: false,
      // 当前选中的选项对象
      selectedOption: null,
    }
  },
  watch: {
    // 监听外部值的变化，同步到组件内部
    value: {
      immediate: true,
      handler(newVal) {
        this.updateSelectedOption(newVal)
      },
    },
  },
  methods: {
    // 切换下拉列表显示状态
    toggleDropdown() {
      if (!this.disabled) {
        this.isOpen = !this.isOpen
      }
    },

    // 处理选项点击
    handleOptionClick(option) {
      if (option.disabled) return

      this.selectedOption = option
      this.isOpen = false
      // 触发外部的input事件，用于v-model绑定
      this.$emit('input', option.value)
      // 触发change事件，传递完整的选项对象
      this.$emit('change', option)
    },

    // 判断选项是否被选中
    isOptionSelected(option) {
      return this.selectedOption === option
    },

    // 根据外部值更新选中的选项对象
    updateSelectedOption(value) {
      if (value === null || value === undefined) {
        this.selectedOption = null
        return
      }

      // 查找匹配的选项
      const matchedOption = this.options.find(
        option => option.value === value,
      )
      this.selectedOption = matchedOption || null
    },
    // 处理外部点击
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.isOpen = false
      }
    },
  },
  mounted() {
    // 点击外部关闭下拉列表
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    // 移除事件监听
    document.removeEventListener('click', this.handleClickOutside)
  },
}
</script>

<style scoped lang="scss">
.custom-select {
  position: relative;
  user-select: none;

  &.is-disabled {
    .select-header {
      pointer-events: none;
      opacity: 0.4;
    }
  }

  .select-header {
    font-family: HYQiHei;
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    line-height: 21px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 8px 5px 10px;
    cursor: pointer;
    transition: all 0.2s;
    color: #666666;
    border: 0.5px solid rgba(0, 0, 0, 0.16);
    border-radius: 8px;
    gap: 4px;

    &:hover {
      // border-color: #666666;
      background: rgba(0, 0, 0, 0.03);
    }

    .selected-value {
      overflow: hidden;
      flex: 1;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .arrow-icon {
      font-size: 12px;
      width: 12px;
      height: 12px;
      transition: transform 0.2s;
      background: #666666;
      mask-image: url(@/assets/images/common/arrow.svg);

      &.rotate {
        transform: rotate(180deg);
      }
    }
  }

  .options-list {
    position: absolute;
    z-index: 9999;
    top: 100%;
    right: 0;
    left: 0;
    overflow-y: auto;
    width: 120px;
    max-height: 200px;
    margin-top: 8px;
    padding: 4px;
    border: 0.5px solid rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    background: #ffffff;
    box-shadow: 0 4px 40px 0 rgba(0, 0, 0, 0.08);

    .option-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 12px 8px 12px 12px;
      cursor: pointer;
      transition: all 0.2s;
      border-radius: 4px;

      .sp {
        &.sp1 {
          font-family: HYQiHei;
          font-size: 14px;
          font-weight: 400;
          font-style: normal;
          text-transform: uppercase;
          color: #333333;
        }

        &.sp2 {
          visibility: visible;
          width: 16px;
          height: 16px;
          opacity: 0;
          background: #1f60ed;
          mask-image: url(@/assets/images/common/checked.svg);
        }
      }

      &:hover:not(.is-disabled) {
        background: rgba(0, 0, 0, 0.02);
      }

      &.is-selected {
        color: #1f60ed;

        .sp2 {
          visibility: visible;
          opacity: 1;
        }
      }

      &.is-disabled {
        cursor: not-allowed;
        color: #999999;
        background-color: transparent;
      }
    }
  }
}
</style>
